import {Message} from '../../../_metronic/helpers'
import {getPartnersById} from '../../../api/AdminAPI'
import {PartnerMasterInput} from '../../types/AdminModuleTypes'
import {APIResponse, InputErrorType, TableHeaderDataType} from '../../types/OtherTypes'

export const getPartnerByID = (
  id: string,
  formField: PartnerMasterInput,
  setFormField: Function,
  setEditId: Function,
  setInputError: Function,
  setShowForm: Function
) => {
  getPartnersById(id).then((res: APIResponse) => {
    if (res.statusCode === 200) {
      setFormField({
        ...formField,
        companyName: res?.data?.partnerCompany,
        partnerName: res?.data?.partnerName,
        contactNo: res?.data?.contact,
        panNo: res?.data?.panCard,
        aadharNo: res?.data?.aadharCard,
        gstNo: res?.data?.gstNumber,
        gstApplicable: res?.data?.gstApplicable,
        gstReason: res?.data?.gstReason,
        address: res?.data?.registerAddress,
        email: res?.data?.email,
        role: res?.data?.partnerName,
        panDoc: res?.data?.panCardFile
          ? new File(
              [
                new Blob([new Uint8Array(res?.data?.panCardFile.fileData.data)], {
                  type: 'image/png',
                }),
              ],
              res?.data?.panCardFile.fileName,
              {type: 'image/png'}
            )
          : null,
        aadharDoc: res?.data?.aadharCardFile
          ? new File(
              [
                new Blob([new Uint8Array(res?.data?.aadharCardFile.fileData.data)], {
                  type: 'image/png',
                }),
              ],
              res?.data?.aadharCardFile.fileName,
              {type: 'image/png'}
            )
          : null,
        gstDoc: res?.data?.gstNumberFile
          ? new File(
              [
                new Blob([new Uint8Array(res?.data?.gstNumberFile.fileData.data)], {
                  type: 'image/png',
                }),
              ],
              res?.data?.gstNumberFile.fileName,
              {type: 'image/png'}
            )
          : null,
      })
      setEditId(id)
      setInputError({})
      setShowForm(true)
    } else {
      Message(res.message, 'error')
    }
  })
}

export const validateForm = (formField: PartnerMasterInput) => {
  let cnt: number = 0
  const error: InputErrorType = {}
  let addressRegex = /^[a-zA-Z0-9][\w\W]*[a-zA-Z0-9)]+$/
  let addressInvalidCharacters = /[<>:"\\|?*\x00-\x1F~`!@#^+=;'[\]{}%_&$]/
  let alphaRegex = /^[a-z][a-z .']*[a-z]*$/i
  let fileregex = /^.+\.(png|jpg|pdf|jpeg)$/i
  if (!formField.partnerName.trim()) {
    cnt = cnt + 1
    error.partnerName = 'Partner Name is Required'
  } else {
    if (!alphaRegex.test(formField.partnerName.trim())) {
      cnt = cnt + 1
      error.partnerName =
        "Only letters (a-z,A-Z) and single space , . , 'between two characters are allowed and last or first character of the Partner Name must be letter (a-z,A-Z)"
    } else if (/(?=([^\w\d]))\1{2,}/g.test(formField.partnerName.trim())) {
      cnt = cnt + 1
      error.partnerName =
        "Only letters (a-z,A-Z) and single space , . , ' between two characters are allowed and last or first character of the Partner Name must be letter (a-z,A-Z)"
    } else {
      if (formField.partnerName.replaceAll(' ', '').length > 50) {
        cnt = cnt + 1
        error.partnerName = 'Partner Name should not be greater than 50 characters'
      }
    }
  }

  if (!formField.companyName.trim()) {
    cnt = cnt + 1
    error.companyName = 'Company Name is Required'
  } else {
    if (!alphaRegex.test(formField.companyName.trim())) {
      cnt = cnt + 1
      error.companyName =
        "Only letters (a-z,A-Z) and single space , . , 'between two characters are allowed and last or first character of the Company Name must be letter (a-z,A-Z)"
    } else if (/(?=([^\w\d]))\1{2,}/g.test(formField.companyName.trim())) {
      cnt = cnt + 1
      error.companyName =
        "Only letters (a-z,A-Z) and single space , . , ' between two characters are allowed and last or first character of the Company Name must be letter (a-z,A-Z)"
    } else {
      if (formField.companyName.replaceAll(' ', '').length > 50) {
        cnt = cnt + 1
        error.companyName = 'Company Name should not be greater than 50 characters'
      }
    }
  }

  if (!formField.address.toString()) {
    cnt = cnt + 1
    error.address = 'Address is Required'
  } else {
    if (formField.address.replaceAll(' ', '').length <= 2) {
      cnt = cnt + 1
      error.address = 'Address must be greater than 2 characters'
    } else {
      if (!addressRegex.test(formField.address.trim())) {
        cnt = cnt + 1
        error.address = 'Address must start with letter or number and end with letter, numbers or )'
      } else {
        if (addressInvalidCharacters.test(formField.address.trim())) {
          cnt = cnt + 1
          error.address = 'Only ( ) , . - / this Special Characters allowed '
        } else if (/(?=([^\w\d]))\1{2,}/g.test(formField.address.trim())) {
          cnt = cnt + 1
          error.address = 'Recurring Special Characters are not allowed'
        } else {
          if (formField.address.replaceAll(' ', '').length > 50) {
            cnt = cnt + 1
            error.address = 'Address should not be greater than 50 characters'
          }
        }
      }
    }
  }

  // if (!formField.email.toString()) {
  //   cnt = cnt + 1
  //   error.email = 'Email is Required'
  // } else if (!validator.isEmail(formField.email)) {
  //   cnt = cnt + 1
  //   error.email = 'Please enter valid email'
  // }

  if (!formField.email) {
    cnt = cnt + 1
    error.email = 'Please enter a Email.'
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const doubleDotRegex = /\.\./
    if (!emailRegex.test(formField.email) || doubleDotRegex.test(formField.email)) {
      cnt = cnt + 1
      error.email = 'Please enter a valid email.'
    }
  }

  if (!formField.contactNo.toString()) {
    cnt = cnt + 1
    error.contactNo = 'Contact No. is Required'
  } else {
    if (formField.contactNo.toString().includes('.')) {
      cnt = cnt + 1
      error.contactNo = 'Decimal is not allowed in contact no.'
    } else if (formField.contactNo.toString().replaceAll('.', '').length !== 10) {
      cnt = cnt + 1
      error.contactNo = 'Contact No. should be 10 digits'
    }
  }
  if (!formField.gstApplicable) {
    cnt = cnt + 1
    error.gstApplicable = 'Please select GSTIN is applicable or not'
  }

  if (formField.gstApplicable === 'true') {
    if (!formField.gstNo) {
      cnt = cnt + 1
      error.gstNo = 'GSTIN No. is required'
    } else {
      if (!/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}Z[A-Z\d]{1}/.test(formField.gstNo)) {
        cnt = cnt + 1
        error.gstNo = 'Please enter valid GSTIN No.'
      }

      if (!formField.gstDoc) {
        cnt = cnt + 1
        error.gstDoc = 'GSTIN Document is Required'
      } else if (formField.gstDoc) {
        if (!fileregex.test(formField?.gstDoc?.name ?? '')) {
          cnt = cnt + 1
          error.gstDoc = 'File type is not allowed'
        }
      }
    }
  } else if (formField.gstApplicable === 'false') {
    if (!formField.gstReason) {
      cnt = cnt + 1
      error.gstApplicable = 'Please enter reason for GST No. not applicable'
    }
  }

  if (!formField.panDoc) {
    cnt = cnt + 1
    error.panDoc = 'Pan Card is Required'
  } else if (formField.panDoc) {
    if (!fileregex.test(formField?.panDoc?.name ?? '')) {
      cnt = cnt + 1
      error.panDoc = 'File type is not allowed'
    }
  }

  if (!formField.aadharDoc) {
    cnt = cnt + 1
    error.aadharDoc = 'Aadhar Card is Required'
  } else if (formField.aadharDoc) {
    if (!fileregex.test(formField?.aadharDoc?.name ?? '')) {
      cnt = cnt + 1
      error.aadharDoc = 'File type is not allowed'
    }
  }
  if (!formField.aadharNo) {
    cnt = cnt + 1
    error.aadharNo = 'Aadhar No is required'
  } else {
    if (!/^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/.test(formField.aadharNo)) {
      cnt = cnt + 1
      error.aadharNo = 'Please enter valid Aadhar No'
    }
  }

  if (!formField?.panNo?.toUpperCase()) {
    cnt = cnt + 1
    error.panNo = 'Pan Card No is required'
  } else {
    if (!/[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(formField?.panNo?.toUpperCase())) {
      cnt = cnt + 1
      error.panNo = 'Please enter valid Pan Card No'
    }
  }

  return {error, cnt}
}

export const partnerTableHeaderData: TableHeaderDataType[] = [
  {
    th: {
      id: 'partnerName',
      style: {
        minWidth: '90px',
        width: '100px',
      },
    },
    text: 'Partner Name',
  },
  {
    th: {
      id: 'partnerCompany',
      style: {
        minWidth: '90px',
        width: '100px',
      },
    },
    text: 'Company Name',
  },
  {
    th: {
      id: 'email',
      style: {
        minWidth: '90px',
        width: '100px',
      },
    },
    text: 'Email',
  },

  {
    th: {
      id: 'contact',
      style: {
        minWidth: '90px',
        width: '100px',
      },
    },
    text: 'Contact No',
  },
  {
    th: {
      id: 'address',
      style: {
        minWidth: '90px',
        width: '100px',
      },
    },
    text: 'Address',
  },

  {
    th: {
      id: 'actions',
      style: {
        width: '100px',
        minWidth: '70px',
      },
    },
    text: 'Actions',
    justifyContent: 'end',
    isSortable: false,
  },
]
